module.exports = "https://www.gc-qa.gnp.com.mx/83baad29244388cb6a14c0f7cad56733.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/asistenciaDental_14p.svg
// module id = 936
// module chunks = 0